module.exports = __webpack_public_path__ + "img/visa.8b66165a.svg";